//import controller from './blog-slider.controller';
import controller from '../blog.controller';
//import templateBase from './templates/blog-slider-base.view.html';
import templateT1 from './templates/blog-slider-t1.view.html';
import templateAD from './templates/blog-slider-adaptative.html';

let BlogSliderComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) {
        return templateAD;
    } else { 
            return templateT1
    }
}

export default BlogSliderComponent;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog-slider/blog-slider.component.js
 **/